import LoaderSpinner from "../ui/LoaderSpinner";

const MessageSkeleton = () => {
  const skeletonMessages = Array(6).fill(null);

  return (
    <div className="flex-1 overflow-y-auto p-5 space-y-4">
      {skeletonMessages.map((_, idx) => {
        const isEnd = idx % 2 !== 0;
        return (
          <div
            key={idx}
            className={`flex items-end gap-2 ${
              isEnd ? "justify-end" : "justify-start"
            }`}
          >
            {!isEnd && (
              <div className="size-9 rounded-full bg-slate-200 animate-pulse shrink-0" />
            )}
            <div
              className={`flex flex-col gap-1.5 ${
                isEnd ? "items-end" : "items-start"
              }`}
            >
              <div className="h-3 w-20 bg-slate-200 rounded animate-pulse" />
              <div
                className={`h-12 rounded-2xl animate-pulse ${
                  isEnd
                    ? "w-48 bg-gradient-to-r from-[#03488A]/10 to-[#00AAF1]/10 rounded-tr-none"
                    : "w-56 bg-slate-200 rounded-tl-none"
                }`}
              />
            </div>
            {isEnd && (
              <div className="size-9 rounded-full bg-slate-200 animate-pulse shrink-0" />
            )}
          </div>
        );
      })}

      <div className="flex justify-center py-4">
        <LoaderSpinner size={36} />
      </div>
    </div>
  );
};

export default MessageSkeleton;
